<template>
  <div class="column">
    <component
      :is="block.component"
      v-for="block in blocks"
      :key="block._uid"
      :blok="block"
    />
  </div>
</template>

<script setup lang="ts">
import type { BlockColumnStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockColumnStoryblok
}>()
const { blocks } = useStoryContent(toRefs(props))
</script>
<style lang="less" scoped>
.column {
  flex-basis: 100%;

  &:not(:first-child) {
    margin-top: @gutter;
  }
  @media @tablet {
    flex-basis: 50%;

    &:not(:first-child) {
      margin-top: 0;
    }
  }
}
</style>
